export const SETTINGS_SECTIONS = {
    searchResults: 'Search & results',
    selectorFields: 'Selector fields',
    storefrontText: 'Storefront text',
    appearance: 'Appearance',
    fitmentDataSources: 'Data management',
    productAttributes: 'Product attributes',
    shopifySync: 'Shopify sync',
    vendorIntegrations: 'Integrations',
    advanced: 'Advanced',
    plan: 'PartFits plan',
} as const;
